import { useCallback } from "react";

import PropTypes from "prop-types";

import { apiClient, StatusEnum } from "@/features/shared";
import { CustomAutocomplete } from "@/features/ui";
import { ProductCategoryTypeEnum } from "../product-category-type";

export const ProductCategorySelect = ({
  type = ProductCategoryTypeEnum.LENS,
  excludedTreeNode = null,
  isLeaf = true,
  ...props
}) => {
  const filterOutVirtualRoot = (categories) =>
    categories.filter((category) => category.parentId !== null);

  const excludeTreeNodeAndDescendants = (categories, node) =>
    categories.filter((category) => {
      const isVirtualRoot = category.parentId === null;
      const isDescendant = category.lft >= node.lft && category.rgt <= node.rgt;
      return !isVirtualRoot && !isDescendant;
    });

  const fetchProductCategories = useCallback(async () => {
    const {
      data: { data },
    } = await apiClient.get("product-categories", {
      params: {
        status: StatusEnum.ACTIVE,
        type,
        isLeaf,
      },
    });

    return excludedTreeNode
      ? excludeTreeNodeAndDescendants(data, excludedTreeNode)
      : filterOutVirtualRoot(data);
  }, [excludedTreeNode, isLeaf, type]);

  return (
    <CustomAutocomplete
      fetchOptions={fetchProductCategories}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      {...props}
    />
  );
};

ProductCategorySelect.propTypes = {
  type: PropTypes.string,
  excludedTreeNode: PropTypes.shape({
    lft: PropTypes.number,
    rgt: PropTypes.number,
  }),
  isLeaf: PropTypes.bool,
};
